module.exports = __webpack_public_path__ + "img/bg-suc-alipay.7875b587.png";